import { isRegExp, template } from "lodash";
import * as chalk from "chalk";
import { DateTime } from "luxon";
import * as path from "path";

export type BranchMatcher = RegExp | string | boolean | ((branch: string) => boolean);

export function matchBranch(branches: BranchMatcher | BranchMatcher[] | undefined, current?: string) {
  if (current == null) return false;

  return coerceArray(branches).some((b: BranchMatcher) => {
    if (isRegExp(b)) {
      return b.test(current);
    } else if (typeof b === "string") {
      return current === b;
    } else if (typeof b === "function") {
      return b(current);
    } else if (typeof b === "boolean") {
      return b;
    } else {
      return false;
    }
  });
}

export function isIterable(x: any): x is Iterable<any> {
  return Boolean(x && typeof x[Symbol.iterator] === "function");
}

const fundamental = new Set(["number", "boolean", "string", "symbol"]);

export function coerceArray(v: any): any[];
export function coerceArray<T>(v: any, filter: (v: any) => v is T): T[];
export function coerceArray<T>(v: any, filter?: (v: any) => v is T): T[] {
  let arr = !fundamental.has(typeof v) && isIterable(v) ? Array.from(v) : v != null ? [v] : [];
  if (filter) arr = arr.filter(filter);
  return arr;
}

export function hasOwn(obj: unknown, key: string): boolean {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

export function isNonEmptyString(s: any): s is string {
  return typeof s === "string" && s !== "";
}

export function createTemplate(
  format?: string,
  options?: {
    color?: boolean;
    imports?: Record<string, any>;
  }
) {
  options = options || {};

  const color = new chalk.Instance({
    level: options ? 1 : 0,
  });

  return template(format, {
    evaluate: /{%([\S\s]+?)%}/g,
    interpolate: /{{([\S\s]+?)}}/g,
    imports: {
      ...options.imports,
      color,
      path,
      DateTime,
    },
  });
}
